import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { images } from "../../../../constants";
import classes from "./Profile.module.scss";

export interface User {
  user_id: number;
  emp_id?: string;
  email: string;
  username?: string;
  is_active: boolean;
  role_type: string;
  can_read: boolean;
  can_write: boolean;
  can_delete: boolean;
}

function Profile() {
  const navigate = useNavigate();

  const user = useSelector((state: RootState) => state.auth.user as User | null);

  console.log(user);

  return (
    <div className={classes.profile}>
      <div
        onClick={() => {
          user?.can_read &&
            navigate("/user-control")
        }}
        className={classes.profile__avatar}
      >
        <img src={images.avt} alt="avatar" />
      </div>
      <div className={classes.profile__info}>
        <p className={classes.profile__userName}>
          {user?.username || user?.email || "Guest"}
        </p>
        <span className={classes.profile__role}>
          {user?.role_type || "Guest"}
        </span>
      </div>
    </div>
  );
}

export default Profile;
